import { setCookie, getCookie, clearCookie } from "../utils/cookie";

export default class CookieInfo extends HTMLDivElement {

    connectedCallback() {

        // Delete old cookies that closed cookie window, just to keep it clean
        clearCookie("cookieinfo-closed");
        clearCookie("cookieinfo-closed-v2");
        clearCookie("cookieinfo-closed-v3");

        this.allBtn.addEventListener("click", () => { this.SetCookies(true, true); });
        this.selectionBtn.addEventListener("click", () => {
            const allowStatistics = this.querySelector("#cookie-info-statistics").checked;
            this.SetCookies(allowStatistics);
        });
        
    }

    get mtmObject() {
        return "_mtm" in window ? window["_mtm"] : [];
    }

    get allBtn() {
        return this.querySelector("#cookie-info-btn-all");
    }

    get selectionBtn() {
        return this.querySelector("#cookie-info-btn-selection");
    }

    SetCookies = (stats) => {

        setCookie("cookie-statistics", stats);

        // Pushes event to matomo
        this.mtmObject.push({ event: "cookie_approval" });

        const cookieId = this.dataset.dismissableId + "-closed-v4";

        setCookie(cookieId, "true");

    }

}

customElements.define('cookie-info', CookieInfo, { extends: 'div' });